import { InfosPSBENState, InfosPSBEN } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getInfosPSBEN2 } from '@/services/api/psben2/api';
import { axios } from '@/plugins/axios';
import _ from 'lodash';

const namespaced: boolean = true;

export const state: InfosPSBENState = {
	infosPSBEN: undefined,
	error: false,
	loaded: false,
	approvalDashboard: undefined,
	displayErrorDashboard: undefined,
	extensionSessionAvailable: undefined,
	expirationTs: undefined,
	extensions: undefined,
	delayDisplaySession: undefined,
	nirUrgenceEnabled: false,
	vaccinationSearchToDisplay: 3,
	folderDegradeSearchEnabled: false
};

export const mutations: MutationTree<InfosPSBENState> = {
	updateInfosPSBEN(state: InfosPSBENState, infosPSBEN: InfosPSBEN): void {
		state.infosPSBEN = infosPSBEN;
	},
	updateErrorInfosPSBEN(state: InfosPSBENState, error: boolean): void {
		state.error = error;
	},
	updateLoaded(state: InfosPSBENState, loaded: boolean): void {
		state.loaded = loaded;
	},
	updateApprovalDashboard(state: InfosPSBENState, approvalDashboard: boolean) {
		state.approvalDashboard = approvalDashboard;
	},
	updateDisplayErrorDashboard(state: InfosPSBENState, displayErrorDashboard: boolean) {
		state.displayErrorDashboard = displayErrorDashboard;
	},
	updateExtensionSessionAvailable(state: InfosPSBENState, extensionSessionAvailable: boolean) {
		state.extensionSessionAvailable = extensionSessionAvailable;
	},
	updateExpirationTs(state: InfosPSBENState, expirationTs: number) {
		state.expirationTs = expirationTs;
	},
	updateExtensions(state: InfosPSBENState, extensions: number) {
		state.extensions = extensions;
	},
	updateDelayDisplaySession(state: InfosPSBENState, delayDisplaySession: number) {
		state.delayDisplaySession = delayDisplaySession;
	},
	updateNirUrgenceEnabled(state: InfosPSBENState, nirUrgenceEnabled: boolean) {
		state.nirUrgenceEnabled = nirUrgenceEnabled;
	},
	updateVaccinationSearchToDisplay(state: InfosPSBENState, vaccinationSearchToDisplay: number) {
		state.vaccinationSearchToDisplay = vaccinationSearchToDisplay;
	},
	updateFolderDegradeSearchEnabled(state: InfosPSBENState, folderDegradeSearchEnabled: boolean) {
		state.folderDegradeSearchEnabled = folderDegradeSearchEnabled;
	}
};

export const actions: ActionTree<InfosPSBENState, RootState> = {
	fetchInfosPSBEN(state): Promise<string | null> {
		return new Promise((resolve, reject) => {
			return getInfosPSBEN2()
				.then((response: any) => {
					const numRpps = _.get(response, 'data.value.infosRpps.numRpps');
					const psben = _.get(response, 'data.value.psben');

					const infosPSBEN: InfosPSBEN = new InfosPSBEN({
						infosPS: _.get(response, 'data.value.infosPsben.infosPS'),
						numRpps,
						assure: _.get(response, 'data.value.infosPsben.infosASSURE'),
						beneficiaire: _.get(response, 'data.value.infosPsben.infosBENEF')
					});

					// Envoie du RPPS en header pour les traces applicatives
					axios.defaults.headers.common.rpps = numRpps;

					state.commit('updateInfosPSBEN', infosPSBEN);
					state.commit('updateLoaded', true);
					state.commit('updateApprovalDashboard', _.get(response, 'data.value.approval'));
					state.commit('updateDisplayErrorDashboard', _.get(response, 'data.value.displayError'));
					state.commit('updateExpirationTs', _.get(response, 'data.value.infosPsben.expirationTs'));
					state.commit('updateExtensions', _.get(response, 'data.value.infosPsben.extensions'));
					state.commit('updateDelayDisplaySession', _.get(response, 'data.value.delayDisplaySession'));
					state.commit('updateExtensionSessionAvailable', _.get(response, 'data.value.extensionAvailable'));
					state.commit('updateNirUrgenceEnabled', _.get(response, 'data.value.nirUrgenceEnabled') || false);
					state.commit('updateVaccinationSearchToDisplay', _.get(response, 'data.value.vaccinationSearchToDisplay'));
					state.commit('updateFolderDegradeSearchEnabled', _.get(response, 'data.value.folderDegradeSearchEnabled'));

					resolve(psben);
				})
				.catch((error: any) => {
					state.commit('updateLoaded', true);
					state.commit('updateErrorInfosPSBEN', true);
					reject();
				});
		});
	}
};

export const getters: GetterTree<InfosPSBENState, RootState> = {
	getInfosPSBEN(state) {
		return state.infosPSBEN;
	},
	getErrorInfosPSBEN(state) {
		return state.error;
	},
	getLoaded(state) {
		return state.loaded;
	},
	getApprovalDashboard(state): boolean | undefined {
		return state.approvalDashboard;
	},
	getDisplayErrorDashboard(state): boolean | undefined {
		return state.displayErrorDashboard;
	},
	getExtensionSessionAvailable(state): boolean | undefined {
		return state.extensionSessionAvailable;
	},
	getExpirationTs(state): number | undefined {
		return state.expirationTs;
	},
	getExtensions(state): number | undefined {
		return state.extensions;
	},
	getDelayDisplaySession(state): number | undefined {
		return state.delayDisplaySession;
	},
	getNirUrgenceEnabled(state): boolean {
		return state.nirUrgenceEnabled;
	},
	getVaccinationSearchToDisplay(state): number {
		return state.vaccinationSearchToDisplay;
	},
	getFolderDegradeSearchEnabled(state): boolean {
		return state.folderDegradeSearchEnabled;
	}
};

export const infosPSBEN: Module<InfosPSBENState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
